import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuthForm } from '../hooks/useAuthForm';

export default function ChangePassword() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const { loading, error, success, updatePassword } = useAuthForm();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      return;
    }
    await updatePassword(newPassword);
  };

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-white">
            Change your password
          </h2>
          <p className="mt-2 text-gray-400">
            Enter your new password below
          </p>
        </div>

        <div className="bg-white/5 backdrop-blur-xl p-8 rounded-2xl border border-white/10">
          <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
              <div className="bg-red-500/10 text-red-400 p-3 rounded-lg text-sm">
                {error}
              </div>
            )}

            {success && (
              <div className="bg-green-500/10 text-green-400 p-3 rounded-lg text-sm">
                {success}
              </div>
            )}

            <div>
              <label htmlFor="newPassword" className="block text-sm font-medium text-gray-300">
                New password
              </label>
              <input
                id="newPassword"
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="mt-1 block w-full rounded-md bg-white/5 border border-white/10 px-3 py-2 text-white focus:border-indigo-500 focus:ring-indigo-500"
                required
                minLength={6}
              />
            </div>

            <div>
              <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-300">
                Confirm the password
              </label>
              <input
                id="confirmPassword"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="mt-1 block w-full rounded-md bg-white/5 border border-white/10 px-3 py-2 text-white focus:border-indigo-500 focus:ring-indigo-500"
                required
                minLength={6}
              />
              {newPassword !== confirmPassword && (
                <p className="mt-1 text-sm text-red-400">
                 The passwords do not match
                </p>
              )}
            </div>

            <button
              type="submit"
              disabled={loading || newPassword !== confirmPassword || newPassword.length < 6}
              className="w-full bg-gradient-to-r from-violet-600 to-cyan-500 text-white px-4 py-2 rounded-xl hover:shadow-[0_0_30px_rgba(79,70,229,0.3)] transition-all disabled:opacity-50"
            >
              {loading ? 'Update...' : 'Update password'}
            </button>
          </form>

          <div className="mt-4 text-center">
            <Link to="/app/settings/profiles" className="text-indigo-400 hover:text-indigo-300 text-sm">
              Back to settings
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}